import {
  Menu, MenuButton, MenuGroup, MenuItem, MenuList,
  styled,
} from "@chakra-ui/react";
import ProfileImage from "../../assets/img/profile.png"
import Image from "../global/Image";
import {ROUTES} from "../../utils/consts/router";
import {useNavigate} from "react-router-dom";
import {useAuthContext} from "../../context/AuthContext";


const Profile = styled("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: "10px",
    marginTop: "15px",
  }
})

const Head = styled("div", {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "32px",
    width: "32px",
    cursor: "pointer",
    backgroundColor: "#F5F5F5",
    borderRadius: "10px",
  }
})

const ProfileName = styled("div", {
  baseStyle: {
    marginLeft: "10px",
    fontFamily: "Mabry Pro",
    fontWeight: "normal",
    fontSize: "15px",
    color: "#48463f",
  }
})

function OverlayProfile() {

  const {handleLogout} = useAuthContext();
  const navigate = useNavigate();

  return (
    <Menu>
      <MenuButton style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <Profile>
          <Head>
            <Image src={ProfileImage} alt="Profile" width={50} borderRadius={10}/>
          </Head>
        </Profile>
      </MenuButton>
      <MenuList>
        <MenuGroup title='Profil'>
          <MenuItem onClick={() => navigate(ROUTES.PROFILE)}>Mon compte</MenuItem>
          <MenuItem onClick={handleLogout}>Déconnexion</MenuItem>
        </MenuGroup>
      </MenuList>
    </Menu>
  )
}

export default OverlayProfile;